import { useState } from 'react';

import type { SheetData } from './types';

/** The sheet to show: the one wanted if the file has it, else the first. */
export function shownSheet(
  sheets: SheetData[],
  wanted: string,
): SheetData | undefined {
  return sheets.find((sheet) => sheet.name === wanted) ?? sheets[0];
}

/**
 * The viewer's open sheet: its own, or the host page's when it passes
 * `sheetName` (a pick is then only reported, and the page decides).
 */
export function useShownSheet(
  sheets: SheetData[],
  sheetName: string | undefined,
  onSheetChange: ((sheetName: string) => void) | undefined,
) {
  const [ownSheet, setOwnSheet] = useState('');
  function selectSheet(name: string): void {
    setOwnSheet(name);
    onSheetChange?.(name);
  }
  return {
    currentSheet: shownSheet(sheets, sheetName ?? ownSheet),
    selectSheet,
  };
}
